import { FC } from 'react';
import { connect } from 'react-redux';
import { ListItem, theme, Box } from '@salecycle/ui-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical } from '@fortawesome/free-solid-svg-icons';
import { SortableHandle } from 'react-sortable-hoc';
import styled from 'styled-components';

import { Campaign } from 'entities/campaign';
import { Selectors as Campaigns } from 'sections/campaigns/state/campaigns';
import { Selectors as SplitTests } from 'sections/campaigns/state/splitTests';
import { State } from 'store';
import StateBadge from '../../components/StateBadge';
import { getActivityState } from 'entities/lifecycle/activityState';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const StyleOptions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 150px;
`;

const StyledDragHandle = styled.div`
  display: flex;
  justify-content: center;
  cursor: grab;
`;

const StyledListMeta = styled.div`
  display: flex;
  align-items: center;
`;

const StyledPriorityNumber = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2rem;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
`;

interface IOwnProps {
  campaignId: string;
  priorityNumber: number;
  onActiveCampaign: () => void;
}

interface IStateProps {
  campaign: Campaign;
  splitTestName: string;
}

export type IProps = IOwnProps & IStateProps;

const DragHandle = SortableHandle(() => (
  // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
  <StyledDragHandle tabIndex={0}>
    <FontAwesomeIcon icon={faGripVertical as IconProp} color={theme.vars.newColor.darkGS2} />
  </StyledDragHandle>
));

export const Row: FC<IProps> = ({ campaign, splitTestName, priorityNumber, onActiveCampaign }: IProps) => {
  const activityState = getActivityState(campaign);
  if (activityState === 'Live' || activityState === 'Testing' || activityState === 'Migration') {
    onActiveCampaign();
    return (
      <ListItem
        variation="full-border"
        options={
          <StyleOptions>
            <Box margin="0 2rem 0 0">
              <StateBadge lifeCycle={campaign} />
            </Box>
            <DragHandle />
          </StyleOptions>
        }
      >
        <StyledListMeta>
          <StyledPriorityNumber>{priorityNumber}</StyledPriorityNumber>
          <span className="name">{campaign.name}</span>
          {splitTestName && <p>{`In A/B Test: ${splitTestName}`}</p>}
        </StyledListMeta>
      </ListItem>
    );
  }
  return <div />;
};

export const mapState = (state: State, ownProps: IOwnProps): IStateProps => {
  const splitTests = SplitTests.getEntities(state);
  const splitTest = splitTests
    .filter(test => test.state !== 'DELETED')
    .find(test => !!test.splits.find(split => split.value === ownProps.campaignId));

  return {
    campaign: Campaigns.getEntity(state, ownProps.campaignId),
    splitTestName: splitTest && splitTest.name,
  };
};

export default connect(mapState)(Row);
